import gql from 'graphql-tag';

export default gql`
  mutation DeleteEmailAlias($emailAlias: String!, $accountId: ID!) {
    deleteEmailAlias(emailAlias: $emailAlias, accountId: $accountId) {
      success
    }
  }
`;
